import {
  Button,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import DeleteConfirm from "../../adminComponents/DeleteConfirm";
import getClientService from "../../../../services/getClientService";
import getUserService from "../../../../services/getUserService";

const columns = [
  //   { id: 'id', label: '' },
  // { id: 'id', label: 'Client id', minWidth: 350, align: 'center' },
  {
    id: "Date",
    label: "Date",
    minWidth: 170,
    format: (value) => value.toLocaleString("en-US"),
    align: "center",
  },
  {
    id: "Name",
    label: "Name",
    minWidth: 170,
    format: (value) => value.toFixed(2),
    align: "center",
  },
  { id: "Email", label: "Email", minWidth: 170, align: "center" },
  {
    id: "Number",
    label: "Number",
    minWidth: 170,
    format: (value) => value.toLocaleString("en-US"),
    align: "center",
  },
  {
    id: "Status",
    label: "Role",
    minWidth: 170,
    format: (value) => value.toLocaleString("en-US"),
    align: "center",
  },
  {
    id: "Action",
    label: "Action",
    minWidth: 250,
    format: (value) => value.toFixed(2),
    align: "center",
  },
];
const List = ({
  user,
  fetchUser,
  filterVal,
  setFilterVal,
  setSelectedUser,
  handleClickOpenAddDialog,
}) => {
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const handleClose = () => {
    setOpenDelete(false);
  };
  const handleChangePage = (event, newPage) => {
    console.log(newPage);
    setFilterVal({ ...filterVal, pageNumber: newPage });
  };
  const handleDelete = async () => {
    try {
      const list = await getUserService.DeleteUser(selectedRow.id);
      fetchUser();
      setOpenDelete(false);
      setSelectedUser(null);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  const handleClickDelete = (row) => {
    setSelectedRow(row);
    setOpenDelete(true);
  };
  const handleClickEditUser = (value) => {
    setSelectedUser(value);
    handleClickOpenAddDialog();
  };
  return (
    <div className="table_style_main">
      <TableContainer sx={{ minHeight: "62vh", maxHeight: "74vh" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {user?.length > 0 ? (
              user.map((row) => (
                <TableRow key={row.id} className="text-center">
                  <TableCell align="center">
                    {moment(row.createdAt).format("MMM Do YY")}
                  </TableCell>
                  <TableCell align="center">
                    {row.first_name + " " + row.last_name}
                  </TableCell>
                  <TableCell align="center">{row.email}</TableCell>
                  <TableCell align="center">{row.phone_num}</TableCell>
                  <TableCell align="center">
                    {row.role == "1" ? "Accountant" : "TL"}
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => handleClickEditUser(row)}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="contained"
                      className="ms-2"
                      color="secondary"
                      size="small"
                      onClick={() => handleClickDelete(row)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <h1>No data found</h1>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="d-flex justify-content-end mt-3 mb-3 px-4">
        <Pagination
          page={filterVal.pageNumber}
          onChange={handleChangePage}
          count={filterVal.totalPages}
          variant="outlined"
          color="primary"
        />
      </div>
      <DeleteConfirm
        openDelete={openDelete}
        handleDelete={handleDelete}
        handleClose={handleClose}
      />
    </div>
  );
};

export default List;
